// Vendor imports
const { combineReducers } = require('redux-immutable')
// Entry imports
const RootRecord = require('client-v2/logged-out-landing/state/record')

const reducers = {
  // Common state
  ...require('client-v2/common/state/reducers'),
  // Common containers
  authModal: require('client-v2/common/containers/auth-modal/reducer'),
  confirmModal: require('client-v2/common/containers/confirm-modal/reducer'),
  toasts: require('client-v2/common/containers/toasts/reducer'),
  // Entry containers
  smsModal: require('client-v2/into-landing/containers/sms-modal/reducer'),
  // No reducer; no actions are supported
  users: state => state,
  video: state => state
}

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
